import React from "react";
import "../../../groups/Groups.css";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import {Comparator, dateFilter, textFilter} from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import Button from "react-bootstrap/Button";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import StorageService from "../../../../services/StorageService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import {
  Col,
  Container,
  Row,
  Spinner,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DeleteDialog from "../../../../components/dialogs/deleteDialog/DeleteDialog";
import ApplicationActionCell from "./applicationsActionCell/ApplicationActionCell";
import CreateApplicationDialog from "./dialogs/createApplicationDialog/CreateApplicationDialog";
import UpdateDepartmentDialog from "./dialogs/updateApplicationDialog/UpdateApplicationDialog";
import DateTimeHelper from "../../../../helpers/DateTimeHelper";
import ShowSecretsDialog from "./dialogs/createApplicationDialog/ShowSecretDialog";
import RenewTokenDialog from "./dialogs/renewTokenDialog/RenewTokenDialog";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import PaginationTableFilterToggle
  from "../../../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class ApplicationsTab extends React.Component {
  tableId = "applicationTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      applications: [],
      showRenewTokenDialog: false,
      showCreateApplicationModal: false,
      showDeleteSingleDepartmentModal: false,
      showUpdateApplicationModal: false,
      showMembersModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      applicationToDeleteOrEdit: null,
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
      isDeleting: false,
      isUpdating: false,
      onlineInstanceTemplates: [],
      secretsDialogShow: false,
      currentSecret: "",
      showInfoModal: false,
    };

    this.handleCreateApplication = this.handleCreateApplication.bind(this);
    this.handleUpdateApplication = this.handleUpdateApplication.bind(this);
    this.handleDeleteApplication = this.handleDeleteApplication.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.handleRenewToken = this.handleRenewToken.bind(this);
    this.getLanguage = this.getLanguage.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();

    try {
      let applications = StorageService.getReferenceType("applications");
      let instanceTemplates = StorageService.getReferenceType(
        "instanceTemplates"
      );

      if (applications) {
        this.setState({ applications: applications });
      }

      if (instanceTemplates) {
        const onlineInstanceTemplates = instanceTemplates?.filter(
          (i) => i.type === 1
        );
        this.setState({ onlineInstanceTemplates });
      }

      applications = await CamplaCoreService.getAllApplications();

      StorageService.set("applications", applications);
      this.setState({ applications });

      instanceTemplates = await CamplaCoreService.getAllInstanceTemplates();

      const onlineInstanceTemplates = instanceTemplates.filter(
        (i) => i.type === 1
      );

      StorageService.set("instanceTemplates", instanceTemplates);
      this.setState({ onlineInstanceTemplates });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ apiError: "" });
          },
          {},
          this.props.t
        ),
      });
    }
  }

  async handleCreateApplication(applicationToCreate) {
    try {
      const createdApplication = await CamplaCoreService.createApplication(
        applicationToCreate
      );

      this.state.applications.push(createdApplication);

      this.setState({
        showCreateApplicationModal: false,
        applications: Object.assign([], this.state.applications),
        currentSecret: createdApplication.secret,
        applicationToDeleteOrEdit: createdApplication,
        secretsDialogShow: true,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
          },
          this.props.t
        ),
      });
    }
  }

  async handleRenewToken(renewalData) {
    try {
      const renewedApplication = await CamplaCoreService.renewApplicationSecret(
        this.state.applicationToDeleteOrEdit._id,
        renewalData
      );

      const { secret, ...renewedWithoutSecret } = renewedApplication;

      const updatedApplications = this.state.applications.map((app) =>
        app._id === renewedWithoutSecret._id ? renewedWithoutSecret : app
      );

      StorageService.set("applications", updatedApplications);

      this.setState({
        showRenewTokenDialog: false,
        applications: updatedApplications,
        currentSecret: secret,
        secretsDialogShow: true,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateApplication(changedApplication) {
    try {
      this.setState({ isUpdating: true });

      const updatedApplication = await CamplaCoreService.updateApplication(
        this.state.applicationToDeleteOrEdit._id,
        changedApplication
      );

      let index = this.state.applications
        .map((c) => c._id)
        .indexOf(this.state.applicationToDeleteOrEdit._id);
      if (index !== -1) {
        this.state.applications[index] = updatedApplication;
      }
      this.setState({
        showUpdateApplicationModal: false,
        applications: Object.assign([], this.state.applications),
        applicationToDeleteOrEdit: null,
        isUpdating: false,
      });
    } catch (err) {
      this.setState({
        isUpdating: false,
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
            NOT_FOUND: "Organisation.APIError.NotFound",
            CONFLICT: "Organisation.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  handleOnDelete(sClass) {
    this.setState({
      applicationToDeleteOrEdit: sClass,
      showDeleteSingleDepartmentModal: true,
    });
  }

  async handleDeleteApplication() {
    this.setState({ isDeleting: true });

    try {
      await CamplaCoreService.deleteApplication(
        this.state.applicationToDeleteOrEdit._id
      );

      const index = this.state.applications.findIndex(
        (obj) => obj._id === this.state.applicationToDeleteOrEdit._id
      );
      if (index !== -1) {
        const newApplications = this.state.applications.filter(
          (obj) => obj._id !== this.state.applicationToDeleteOrEdit._id
        );
        this.setState(
          {
            applications: newApplications,
            showDeleteSingleDepartmentModal: false,
            applicationToDeleteOrEdit: null,
            isDeleting: false,
          },
          () => {}
        );
      }
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Organisation.APIError.PreconditionFailed",
            NOT_FOUND: "Organisation.APIError.NotFound",
            CONFLICT: "Organisation.APIError.DeleteConflict",
          },
          this.props.t
        ),
        isDeleting: false,
      });
    }
  }

  getLanguage(cell) {
    const i18n = this.props.i18n;
    const usedLang = (i18n.resolvedLanguage || i18n.language || "en").split(
      "-"
    )[0];
    const filteredLangs = Object.entries(cell)
      .filter(([lang, value]) => value !== "")
      .map(([lang]) => lang);
    const finalLang = filteredLangs.includes(usedLang)
      ? usedLang
      : filteredLangs[0];

    return cell[finalLang];
  }

  getBody() {
    const { t } = this.props;

    const dep = this.props.departments
      .filter(
        (d) =>
          d._id === this.state.applicationToDeleteOrEdit?.options?.departmentId
      )
      .map((d) => this.getLanguage(d?.description));

    const instanceName = this.state?.onlineInstanceTemplates
      .filter(
        (i) =>
          i._id ===
          this.state.applicationToDeleteOrEdit?.options?.instanceTemplateId
      )
      .map((i) => i.name);

    const showArray = [
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.Label"),
        value: this.state.applicationToDeleteOrEdit?.name,
      },
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.Identifier"),
        value: this.state.applicationToDeleteOrEdit?.identifier,
      },
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.BaseUrl"),
        value: window.location.origin,
      },
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.Expiration"),
        value: DateTimeHelper.formatDate(
          this.state.applicationToDeleteOrEdit?.expiration
        ),
      },
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.Department"),
        value: dep,
      },
      {
        label: t(
          "Organisation.ApplicationTabbar.ShowInfoDialog.InstanceTemplate"
        ),
        value: instanceName,
      },
    ];

    return (
      <>
        {showArray.map((i) => (
          <Row className="mb-2">
            <Col sm={4} className="fw-bold">
              <b>{i.label}</b>
            </Col>
            <Col sm={8}>{i.value}</Col>
          </Row>
        ))}
      </>
    );
  }

  async showOneTimeSecret(secret) {
    try {
      if (secret) {
        this.setState({
          currentSecret: secret,
          secretsDialogShow: true,
        });
      }
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const memberData = {
      count: Date.now(),
    };

    const info = [
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.Identifier"),
        value: this.state.applicationToDeleteOrEdit?.identifier,
      },
      {
        label: t("Organisation.ApplicationTabbar.ShowInfoDialog.BaseUrl"),
        value: window.location.origin,
      },
    ];

    const columns = [
      {
        dataField: "name",
        text: t("Organisation.ApplicationTabbar.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t(
            "Organisation.ApplicationTabbar.FilterNamePlaceholder"
          ),
          style: { width: "auto", display: this.state.displayFilter },
        }),
      },
      {
        dataField: "expiration",
        text: t("Organisation.ApplicationTabbar.ColumnExpiration"),
        sort: true,
        filter: dateFilter({
          style: { display: this.state.displayFilter },
          defaultValue: { date: undefined, comparator: Comparator.EQ },
        }),
        formatter: (cell) => DateTimeHelper.formatDate(cell),
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, sClass) => (
          <ApplicationActionCell
            onEdit={() => {
              this.setState({
                showUpdateApplicationModal: true,
                applicationToDeleteOrEdit: sClass,
              });
            }}
            onDelete={() => this.handleOnDelete(sClass)}
            onNewToken={() => {
              this.setState({
                showRenewTokenDialog: true,
                applicationToDeleteOrEdit: sClass,
              });
            }}
            onShowInfo={() => {
              this.setState({
                showInfoModal: true,
                applicationToDeleteOrEdit: sClass,
              });
            }}
            class={sClass}
          />
        ),
      },
    ];

    return (
      <div>
        <CreateApplicationDialog
          getLanguage={this.getLanguage}
          i18n={this.props.i18n}
          instanceTemplates={this.state.onlineInstanceTemplates}
          departments={this.props.departments}
          show={this.state.showCreateApplicationModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    dialogApiError: null,
                    showCreateApplicationModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateApplicationModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateApplication}
        />

        <RenewTokenDialog
          show={this.state.showRenewTokenDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    dialogApiError: null,
                    showRenewTokenDialog: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showRenewTokenDialog: false,
              });
            }
          }}
          onSubmit={this.handleRenewToken}
        />

        <BaseDialog
          show={this.state.showInfoModal}
          onHide={() => this.setState({ showInfoModal: false })}
          title={t("Organisation.ApplicationTabbar.ShowInfoDialog.Title")}
          body={this.getBody()}
          leftButtonText={t("DialogClose")}
          leftButtonVariant="black"
          leftButtonCallback={() => this.setState({ showInfoModal: false })}
          dialogApiError={this.state.dialogApiError}
        />

        <DeleteDialog
          show={this.state.showDeleteSingleDepartmentModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: null,
              showDeleteSingleDepartmentModal: false,
            })
          }
          onSubmit={this.handleDeleteApplication}
          title={t("Organisation.ApplicationTabbar.DeleteModal.Title")}
          body={
            <div style={this.state.isDeleting ? { textAlign: "center" } : {}}>
              {this.state.isDeleting ? (
                <Spinner animation="border" />
              ) : (
                t("Organisation.ApplicationTabbar.DeleteModal.Text", {
                  className: this.state.applicationToDeleteOrEdit?.identifier,
                })
              )}
            </div>
          }
          rightButtonText={t("Groups.GroupModal.DeleteModal.Submit")}
          leftButtonText={t("Groups.GroupModal.DeleteModal.Cancel")}
        />

        <UpdateDepartmentDialog
          i18n={this.props.i18n}
          getLanguage={this.getLanguage}
          isUpdating={this.state.isUpdating}
          show={this.state.showUpdateApplicationModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showUpdateApplicationModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateApplicationModal: false,
              });
            }
          }}
          onSubmit={this.handleUpdateApplication}
          class={this.state.applicationToDeleteOrEdit}
          departments={this.props.departments}
          instanceTemplates={this.state.onlineInstanceTemplates}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />

        <ShowSecretsDialog
          show={this.state.secretsDialogShow}
          onHide={() =>
            this.setState({ secretsDialogShow: false, currentSecret: "" })
          }
          title={t("Organisation.ApplicationTabbar.TokenRenewal.Title")}
          secret={this.state.currentSecret}
          secretLabel={t("Organisation.ApplicationTabbar.TokenRenewal.Label")}
          hint={t("Organisation.ApplicationTabbar.TokenRenewal.Hint")}
          showCopy={true}
          info={info}
        />

        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h4>{t("Organisation.OrganisationTabbar.ApplicationsTitle")}</h4>
            </Col>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  className="btn-green ml-3"
                  onClick={() => {
                    this.setState({ showCreateApplicationModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <p>
                {t("Organisation.ApplicationTabbar.Description")}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <PaginationTable
                data={this.state.applications}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                formatExtraData={memberData}
                view="applications"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ApplicationsTab);
